import { forwardRef } from "react";
import {
  Display,
  H1,
  H2,
  H3Normal,
  H3Strong,
  H4,
  Props,
  Section,
} from "./Heading.Parts";

export const Heading = forwardRef<HTMLHeadingElement, Props>(
  ({ children, variant = "h1", tag, ...rest }, ref) => {
    switch (variant) {
      case "display":
        return (
          <Display ref={ref} as={tag || "h1"} {...rest}>
            {children}
          </Display>
        );
      case "h1":
        return (
          <H1 ref={ref} as={tag || "h1"} {...rest}>
            {children}
          </H1>
        );
      case "h2":
        return (
          <H2 ref={ref} as={tag || "h2"} {...rest}>
            {children}
          </H2>
        );
      case "h3-normal":
        return (
          <H3Normal ref={ref} as={tag || "h3"} {...rest}>
            {children}
          </H3Normal>
        );
      case "h3-strong":
        return (
          <H3Strong ref={ref} as={tag || "h3"} {...rest}>
            {children}
          </H3Strong>
        );
      case "h4":
        return (
          <H4 ref={ref} as={tag || "h4"} {...rest}>
            {children}
          </H4>
        );
      case "section":
        return (
          <Section ref={ref} as={tag || "h3"} {...rest}>
            {children}
          </Section>
        );
      default:
        return (
          <H1 ref={ref} as={tag || "h1"} {...rest}>
            {children}
          </H1>
        );
    }
  },
);
